var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDisabledMultipleDoc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "multiple-pages"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.20833 15.0001C5.20833 14.6549 5.48816 14.3751 5.83333 14.3751H11.6667C12.0118 14.3751 12.2917 14.6549 12.2917 15.0001C12.2917 15.3453 12.0118 15.6251 11.6667 15.6251H5.83333C5.48816 15.6251 5.20833 15.3453 5.20833 15.0001Z",
    fill: "#9897A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.20833 11.6667C5.20833 11.3216 5.48816 11.0417 5.83333 11.0417H6.66667C7.01184 11.0417 7.29167 11.3216 7.29167 11.6667C7.29167 12.0119 7.01184 12.2917 6.66667 12.2917H5.83333C5.48816 12.2917 5.20833 12.0119 5.20833 11.6667Z",
    fill: "#9897A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.20833 8.33342C5.20833 7.98824 5.48816 7.70842 5.83333 7.70842H8.33333C8.67851 7.70842 8.95833 7.98824 8.95833 8.33342C8.95833 8.67859 8.67851 8.95842 8.33333 8.95842H5.83333C5.48816 8.95842 5.20833 8.67859 5.20833 8.33342Z",
    fill: "#9897A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.20833 1.66675C5.20833 1.32157 5.48816 1.04175 5.83333 1.04175H13.75C13.9158 1.04175 14.0747 1.1076 14.1919 1.22481L17.9419 4.97481C18.0592 5.09202 18.125 5.25099 18.125 5.41675V15.8334C18.125 16.1786 17.8452 16.4584 17.5 16.4584C17.1548 16.4584 16.875 16.1786 16.875 15.8334V5.67563L13.4911 2.29175H5.83333C5.48816 2.29175 5.20833 2.01193 5.20833 1.66675Z",
    fill: "#9897A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.75 4.79175C3.40482 4.79175 3.125 5.07157 3.125 5.41675V17.0834C3.125 17.4286 3.40482 17.7084 3.75 17.7084H13.75C14.0952 17.7084 14.375 17.4286 14.375 17.0834V7.3423L11.8244 4.79175H3.75ZM1.875 5.41675C1.875 4.38121 2.71447 3.54175 3.75 3.54175H11.8762C12.1746 3.54175 12.4607 3.66027 12.6717 3.87125L15.2955 6.49503C15.5065 6.70601 15.625 6.99215 15.625 7.29052V17.0834C15.625 18.1189 14.7855 18.9584 13.75 18.9584H3.75C2.71447 18.9584 1.875 18.1189 1.875 17.0834V5.41675Z",
    fill: "#9897A6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6667 3.54175C12.0118 3.54175 12.2917 3.82157 12.2917 4.16675V6.87508H15C15.3452 6.87508 15.625 7.1549 15.625 7.50008C15.625 7.84526 15.3452 8.12508 15 8.12508H12.1667C11.5453 8.12508 11.0417 7.6214 11.0417 7.00008V4.16675C11.0417 3.82157 11.3215 3.54175 11.6667 3.54175Z",
    fill: "#9897A6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisabledMultipleDoc);
export default __webpack_public_path__ + "static/media/disabled-multiple-doc.6e9496f15af84b615606f67ee3fb96bb.svg";
export { ForwardRef as ReactComponent };